import {
	BaseError,
} from './BaseError';

export class GetSpecificationOffersError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
